import { Screen } from '@bonanza-social/navigation';
import { ScrollView } from 'react-native';
import ContactUsForm from '../components/ContactUsForm/ContactUsForm';
import { Box } from '@bonanza-social/moonlight';

function ContactUsScreen() {
  return (
    <Screen>
      <ScrollView>
        <Box paddingTop="safe-area-inset-top">
          <ContactUsForm />
        </Box>
      </ScrollView>
    </Screen>
  );
}

export default ContactUsScreen;
